
export const getLegalForms = () => {
  return [
    'Einzelfirma', 'GmbH', 'AG', 'Kollektivgesellschaft', 'Kommanditgesellschaft', 'Institut des öffentlichen Rechts'
  ];
}

export const getNumberOfEmployees = () => {
  return [
    '1-9', '10-49', '50-249', '250+'
  ];
}




// WEBPACK FOOTER //
// ./src/services/static-data.services.js